import { ApplicationsListScreen } from "@/interactors/ApplicationsListScreen";

export default function ApplicationsList() {
  return <ApplicationsListScreen />;
}
